import {useTranslation} from 'react-i18next';
import keycardIcon from 'assets/icons/key-card.svg';
import {useGuestGroup} from 'hooks';
import {useKioskoStore} from 'context/kiosko';
import ModalSheet from 'components/common/ModalSheet';
import {ProgressTaskBar} from '../ProgressTaskBar';
import {IncompletePrintedCardContent} from './IncompletePrintedCardContent';
import {CompletePrintedCardContent} from './CompletePrintedCardContent';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onMaybeLater: () => void;
  onGoToKeyCards?: () => void;
};

function PrintedCardsModal({isOpen, onClose, onMaybeLater, onGoToKeyCards}: Props) {
  const {t} = useTranslation();
  const {guestGroup} = useGuestGroup();
  const printed = useKioskoStore(state => state.cards.printed);
  const pending = useKioskoStore(state => state.cards.pending);
  const isAllCardsPrinted = pending === 0;

  return (
    <ModalSheet
      isOpenModalSheet={isOpen}
      handleCloseModal={onClose}
      withCloseButton={false}
      withModalMobileCloseButton={false}
      closeOnDocumentClick={false}
      closeButtonType="none"
      closeOnEscape={false}
      className="[&>div]:py-[40px] [&>div]:px-6 !rounded-[38px]"
    >
      <div className="flex flex-col p-0 w-full gap-14">
        <ProgressTaskBar
          completed={printed}
          total={guestGroup?.known_number_of_guests ?? 0}
          title={t('printed_keycards')}
          icon={<img src={keycardIcon} alt="printed" width={38} height={38} />}
        />
        {isAllCardsPrinted ? (
          <CompletePrintedCardContent onGoToKeyCards={onGoToKeyCards} />
        ) : (
          <IncompletePrintedCardContent onClose={onClose} onMaybeLater={onMaybeLater} />
        )}
      </div>
    </ModalSheet>
  );
}

export {PrintedCardsModal};
